<template>
  <div class="e-field">
    <label v-if="label" class="i-label" :for="name">{{label}}</label>
    <v-icon class="field-icon" v-if="prependIcon">{{prependIcon}}</v-icon>
    <input v-if="type !== 'textarea'" :type="type" :value="value" :placeholder="placeholder" :class="{'solo-field': solo, 'prepend-icon': prependIcon, 'medium-field': medium}" @input="updateValue" @change="updateValue" @blur="$emit('blur')" :disabled="disabled" :name="name" :id="name" :style="`width: ${width}`">
    <textarea v-if="type === 'textarea'" :type="type" :value="value" :placeholder="placeholder" :class="{'solo-field': solo, 'prepend-icon': prependIcon}" @input="updateValue" @change="updateValue" @blur="$emit('blur')" :disabled="disabled" :name="name" :id="name" :style="`min-height: ${minHeight}`"></textarea>
  </div>
</template>

<script>
export default {
  name: 'text-field',
  props: {
    value: String,
    solo: {
      type: Boolean,
      default: false
    },
    prependIcon: {
      type: String,
      default: ''
    },
    width: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      required: false
    },
    type: {
      type: String,
      default: 'text'
    },
    label: {
      type: String,
      default: ''
    },
    labelStyle: {
      type: String,
      default: 'label-default'
    },
    minHeight: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    medium: {
      type: Boolean,
      deafult: false
    }
  },
  methods: {
    updateValue (e) {
      this.$emit('input', e.target.value)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/scss/components/text-field";
</style>



// WEBPACK FOOTER //
// src/components/ui/text-field.vue